
import { Author } from "../../user/objects/author";
import { PictureType, PictureTypes } from "./pictureState";

export interface PictureLocale {
    id?: number,
    locale: number,
    name: string
}

export interface PictureCategoryLocale {
    id?: number,
    locale: number,
    name: string
}

export type PictureCategory = {
    id: number,
    owner: number | null,
    name: null | string,
    localization: PictureCategoryLocale[]
}

export type Picture = {
    description?: null | string,
    id: number,
    alt?: string,
    credits?: string,
    is_active?: boolean,
    type: PictureType,
    name?: null | string,
    thumbnail_big?: null | string,
    thumbnail_little?: null | string,
    thumbnail_medium?: null | string,
    url: null | string,
    creator: Author | null,
    last_author: Author | null,
    created_date: string,
    modified_date: string,
    picture_category?: number | PictureCategory | null,
    localization: PictureLocale[]
}

export interface PictureForm {
    description?: null | string,
    alt?: string | null,
    credits?: string | null,
    type: PictureType,
    name?: null | string,
    file: null | any,
    name_locales: Record<number, string>
    picture_category?: number | null,
    localization: PictureLocale[]
}


export const EMPTY_PICTURE_FORM: PictureForm = {
    description: null,
    alt: null,
    credits: null,
    type: PictureTypes[0],
    name: null,
    file: null,
    name_locales: {},
    picture_category: null,
    localization: []
};